import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { AxiosError } from 'axios';

import axiosInstance from '../configs/axios';

interface NewGameSuggestionProps {
  name_game: string;
  game_link: string;
  description: string;
  observations?: string | null;
  recaptcha: string;
  email: string;
}
export const gameSuggestion = createAsyncThunk('appNewGameSuggestion/gameSuggestion', async (body: NewGameSuggestionProps) => {
  const { name_game, game_link, description, observations, recaptcha, email } = body;
  const data = {
    contact: email,
    type: '1',
    attributes: {
      _default_title_: 'Solicitação de novo jogo',
      _default_description_: `Nome do jogo: ${name_game}\nLink do jogo: ${game_link}\nDescrição: ${description}`,
    },
    recaptcha,
  };

  if (observations) {
    // eslint-disable-next-line no-underscore-dangle
    data.attributes._default_description_ += `\nObservações: ${observations}`;
  }
  return axiosInstance
    .post('/tickets', data)
    .then((res) => {
      return { success: res.data.success, data: res.data };
    })
    .catch((err: AxiosError) => {
      const { response } = err;
      // @ts-ignore
      return { success: false, data: response?.data };
    });
});

export const appPlanSlice = createSlice({
  name: 'appNewGameSuggestion',
  initialState: {
    data: [],
  },
  reducers: {},
});

export default appPlanSlice.reducer;
